static const PATHS = {
  close: "M6 6l12 12M18 6L6 18",
  restart: ["M3.5 12a8.5 8.5 0 1 0 2.5-6", "M3.5 3.5V8H8"],
  right: "M9 6l6 6-6 6",
  left: "M15 6l-6 6 6 6",
  backspace: "M9 5l-7 7 7 7h12V5zM12 9l6 6M18 9l-6 6",
  "delete-letter": [
    "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
    "m12 9 6 6",
    "m18 9-6 6",
  ],
  check: "M5 12.5l4.5 4.5L19 7.5",
  lock: "M7 11V8a5 5 0 0 1 10 0v3M6 11h12v9H6z",
  cup: "M4 5h12v9a5 5 0 0 1-10 0V5M16 6h2a3 3 0 0 1 0 6h-2M4 21h14",
  up: "M6 15l6-6 6 6",
  down: "M6 9l6 6 6-6",
  entrance: "M13 3h7v18h-7M2 12h14M11 7l5 5-5 5",
  exit: "M11 3H4v18h7M8 12h14M17 7l5 5-5 5",
  toilet: "M6 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4M18 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4M3 10h6v6H7v6H5v-6H3zM16 10h4l2 8h-3v4h-2v-4h-3zM12 3v19",
  medicine: ["M10.5 20.5l10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7z", "M8.5 8.5l7 7"],
  bank: ["M3 22h18", "M6 18v-7M10 18v-7M14 18v-7M18 18v-7", "M12 2l8 5H4z"],
  plane: "M22 12l-8-4V3a2 2 0 0 0-4 0v5l-8 4v3l8-2v5l-3 2v2l5-1 5 1v-2l-3-2v-5l8 2z",
  arrivals: "M3 19h18M4 4l5 2 2-3 3 2-1 3 7 5-1 3-8-3-3 2-3-1 1-4-4-4z",
  departures: "M3 19h18M3 12l4 1 5-3-2-4 3-1 3 3 5-2 1 3-15 8-3-1z",
  book: "M12 5v16M12 5C8 2 3 3 2 4v15c4-2 7-1 10 2M12 5c4-3 9-2 10-1v15c-4-2-7-1-10 2",
  school: "M3 21V9l9-6 9 6v12zM9 21v-6h6v6M7 10h2M15 10h2",
  file: "M14 3H7v18h10V6zM14 3v3h3M9.5 12h5M9.5 15.5h5",
  cog: [
    "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
    "M15 12a3 3 0 1 1-6 0 3 3 0 1 1 6 0",
  ],
};

<svg
  class=["ll-course-icon", input.class]
  viewBox="0 0 24 24"
  width=(input.size || 18)
  height=(input.size || 18)
  aria-hidden="true"
  fill="none"
  stroke="currentColor"
  stroke-width=(input.weight || 2.2)
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <if=Array.isArray(PATHS[input.name])>
    <for|d| of=PATHS[input.name]>
      <path d=d/>
    </for>
  </if>
  <else>
    <path d=PATHS[input.name]/>
  </else>
</svg>
